import { Link } from "react-router-dom";
import { SAFETY_DISCLAIMER } from "../../constants/automapTrustSafetyConstants";
import { RISK_DISCLAIMER_ES } from "../../constants/automapVehicleRiskConstants";

export default function SafetyGuidePage({ variant = "seguridad" }) {
  const title = variant === "compra-segura" ? "Guía de compra segura" : "Seguridad en AutoMapa";

  return (
    <main className="wrap" style={{ padding: "2rem", maxWidth: 720 }}>
      <h1>{title}</h1>
      <p>
        AutoMapa ayuda a organizar información, señales de confianza y reportes de usuarios.
        Antes de comprar, verifica documentos, historial, condiciones mecánicas y transferencia
        con fuentes oficiales o profesionales.
      </p>

      <section style={{ marginTop: "1.5rem" }}>
        <h2>¿Qué significa “Verificado por AutoMapa”?</h2>
        <p>
          Un concesionario verificado significa que AutoMapa revisó datos básicos del negocio y su canal
          de atención. Antes de comprar, siempre verifica documentos, historial, condiciones mecánicas,
          SOAT, tecnomecánica y proceso de traspaso.
        </p>
        <ul>
          <li>Revisamos nombre comercial, ubicación o presencia pública del negocio.</li>
          <li>Confirmamos canal de contacto (WhatsApp u otro medio declarado).</li>
          <li>Revisamos fuente básica del inventario publicado en AutoMapa.</li>
          <li>No garantizamos estado mecánico, legal, documental ni resultado de la compra.</li>
          <li>La verificación no es una garantía ni una póliza de compra.</li>
        </ul>
        <p>
          <Link to="/guias/compra-segura">Ver guía completa de compra segura</Link>
        </p>
      </section>

      <section style={{ marginTop: "1.5rem" }}>
        <h2>Qué significa la verificación de concesionarios</h2>
        <ul>
          <li>Revisamos datos básicos del negocio y contacto para operar en la plataforma.</li>
          <li>No garantizamos el comportamiento futuro del concesionario ni el estado de cada vehículo.</li>
          <li>Los reportes de compradores nos ayudan a detectar problemas recurrentes.</li>
        </ul>
      </section>

      <section style={{ marginTop: "1.5rem" }}>
        <h2>Cómo evitar estafas</h2>
        <ul>
          <li>No envíes anticipos sin ver el vehículo y validar documentos.</li>
          <li>Desconfía de precios muy por debajo del mercado o presión para pagar fuera de la plataforma.</li>
          <li>Verifica identidad del vendedor y que el vehículo corresponda al anuncio.</li>
          <li>Usa medios de pago trazables y conserva comprobantes.</li>
        </ul>
      </section>

      <section style={{ marginTop: "1.5rem" }}>
        <h2>Antes de pagar</h2>
        <ul>
          <li>Revisa SOAT y tecnomecánica vigentes.</li>
          <li>Confirma historial de propietarios y posibles multas o gravámenes.</li>
          <li>Inspecciona el vehículo con un mecánico de confianza si es posible.</li>
          <li>Acuerda prueba de manejo en lugar seguro y horario diurno.</li>
        </ul>
      </section>

      <section style={{ marginTop: "1.5rem" }}>
        <h2>Cómo reportar un problema</h2>
        <p>
          Desde la publicación del vehículo o el perfil del concesionario puedes usar
          “Reportar problema”. También puedes contactarnos si ya tuviste una mala experiencia.
        </p>
        <p>
          <Link to="/">Volver al inicio</Link>
        </p>
      </section>

      <section style={{ marginTop: "1.5rem" }}>
        <h2>Señales de revisión en publicaciones</h2>
        <p>
          AutoMapa muestra indicadores como disponibilidad pendiente, información incompleta o precio
          inusual frente a similares. Estas señales ayudan a decidir qué verificar antes de contactar.
        </p>
        <ul>
          <li>“Revisar con cuidado” indica datos que conviene confirmar, no una acusación.</li>
          <li>“Información limitada” significa que faltan datos para evaluar algunas señales.</li>
          <li>Siempre valida documentos, estado del vehículo y disponibilidad directamente con el concesionario.</li>
        </ul>
        <p className="muted">{RISK_DISCLAIMER_ES}</p>
      </section>

      <section style={{ marginTop: "1.5rem" }}>
        <h2>Cómo interpretamos el precio justo</h2>
        <p>
          AutoMapa compara el precio publicado con vehículos similares activos en la plataforma (misma
          marca, modelo y año cercano). Funciona mejor cuando hay suficiente inventario comparable.
        </p>
        <ul>
          <li>No es una tasación oficial ni garantiza el valor real del vehículo.</li>
          <li>Compara también condición, documentos, kilometraje e inspección mecánica.</li>
          <li>Un precio bajo no implica automáticamente una buena compra.</li>
        </ul>
      </section>

      <section style={{ marginTop: "1.5rem" }}>
        <h2>Checklist de compra</h2>
        <p>
          Usa nuestra checklist práctica para revisar documentos, SOAT, tecnomecánica, inspección
          mecánica, pagos y traspaso antes de comprar.
        </p>
        <ul>
          <li><Link to="/checklist-compra">Ver checklist de compra</Link></li>
          <li><Link to="/guias/checklist-compra-carro-usado">Guía completa: checklist carro usado en Colombia</Link></li>
          <li><Link to="/checklist-compra">Usar checklist antes de contactar</Link></li>
          <li><Link to="/guias/checklist-compra-carro-usado#payment">Qué revisar antes de pagar</Link></li>
        </ul>
      </section>

      <p className="muted" style={{ marginTop: "2rem" }}>{SAFETY_DISCLAIMER}</p>
    </main>
  );
}
